import styled, { css } from "styled-components";
import React, {
  Component,
  Fragment,
  useContext,
  useState,
  useEffect
} from "react";

import { withRouter } from "react-router-dom";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Breadcrumbs,
  ContentBlock,
  Card,
  Input,
  RadioGroup,
  Icon,
  Tag,
  FormFooter,
  Notification
} from "xsolla-uikit";

import { sites } from './../data/sites'

import CardNew, {CardItem,  CardTodo, CardSite, CardFlatten } from "./PAcardNew";


import merge from "deepmerge";
import { ContextConsumer, GlobalContext } from './PA';
import { IntlProvider } from "react-intl";
import { Link } from "react-router-dom";
import PAsbStartPopup from "./PAsbStartPopup";

export default props => {
  let globalContext = useContext(GlobalContext);
  return <PAsbProj {...props} globalContext={globalContext} />;
};

const PAsbProj = withRouter(props => {
  const [state, setState] = useState({
    newSite: false
  });

  useEffect(() => {
    console.log("props = ", props);
    if (props.match && props.match.path) {
      if (props.match.path === "/site_builder/new" && !state.newSite) {
        setState({
          newSite: true
        });
      }

      if (props.match.path === "/site-builder" && state.newSite) {
        setState({
          newSite: false
        });
      }
    }
  });




  const handleClose = () =>{
    setState({newSite: false})
  }



  console.log("props1231231212123213 = ", props);

  return (

      <div className="xsui-width">


      {/* {state.newSite && ( */}
          {/* <div className="">
            <PAsbStartPopup/>
          </div> */}
        {/* )} */}


      <FormGroup indentation="md">
        <Breadcrumbs
          items={[
            {
              label: "Site Builder",
              to: "/site_builder/"
            },
          ]}
        />
      </FormGroup>




      <ContentBlock appearance="flatten">
        <CSScards>
          {sites.map((oneSb, ind) => {
            return (
              // <FormGroup indentation="lg" key={`login_${ind}`}>
                <CardItem size="lg" {...oneSb} key={`login_${ind}`} />
              // </FormGroup>
            );
          })}

            <Link to="/site_builder/new">
              <CardFlatten icon="site" title="Create Landing Page" />
            </Link>

        </CSScards>
      </ContentBlock>





      </div>

  );
});




const CSScards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 30%));
  grid-column-gap: 24px;
  grid-row-gap: 24px;
`;